const {
  ACCESSIBILITY_TESTING_MOUNT_POINT,
  APPS_PAGES_MOUNT_POINT,
  COMPANIES_PAGES_MOUNT_POINT,
  CUSTOMERS_PAGES_MOUNT_POINT,
  HELPDOCS_MOUNT_POINT,
  HOMEPAGE_MOUNT_POINT,
  HOW_IT_WORKS_MOUNT_POINT,
  PARTNER_MOUNT_POINT,
  PATHS_MOUNT_POINT,
  PLATFORM_BOUNCER_MOUNT_POINT,
  PLATFORM_CONTENT_SITE_MOUNT_POINT,
  PRESS_PAGES_MOUNT_POINT,
  PRICING_PAGES_MOUNT_POINT,
  PRIVACY_PAGE_MOUNT_POINT,
  SECURITY_MOUNT_POINT,
  SHARING_PUBLIC_MOUNT_POINT,
  ZAP_SHARING_MOUNT_POINT,
  USE_CASES_MOUNT_POINT,
  ZAPPY_MOUNT_POINT,
  X_FRAME_EXEMPT,
} = require('../constants');

const routes = [
  {
    name: 'companies',
    pattern: `/${COMPANIES_PAGES_MOUNT_POINT}`,
    page: '/companies',
  },
  {
    name: 'customers',
    pattern: `/${CUSTOMERS_PAGES_MOUNT_POINT}`,
    page: '/customers/index',
  },
  {
    name: 'helpdocs-category-content',
    pattern: `/${HELPDOCS_MOUNT_POINT}/:category/:subcategory/:content`,
    page: '/helpdocs/content',
  },
  {
    name: 'helpdocs-content',
    pattern: `/${HELPDOCS_MOUNT_POINT}/doc/:content`,
    page: '/helpdocs/content',
  },
  {
    name: 'helpdocs-subcategory',
    pattern: `/${HELPDOCS_MOUNT_POINT}/:category/:subcategory`,
    page: '/helpdocs/subcategory',
  },
  {
    name: 'helpdocs-search',
    pattern: `/${HELPDOCS_MOUNT_POINT}/search`,
    page: '/helpdocs/search',
  },
  {
    name: 'helpdocs-category',
    pattern: `/${HELPDOCS_MOUNT_POINT}/:category`,
    page: '/helpdocs/category',
  },
  {
    name: 'helpdocs',
    pattern: `/${HELPDOCS_MOUNT_POINT}`,
    page: '/helpdocs/index',
  },
  {
    name: 'how-it-works',
    pattern: `/${HOW_IT_WORKS_MOUNT_POINT}`,
    page: '/foundational-pages/how-it-works',
  },
  {
    name: 'demo',
    pattern: '/demo',
    page: '/foundational-pages/demo',
  },
  {
    name: 'platform-content-site-home',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}`,
    page: '/platform/content-site/home',
  },
  {
    name: 'platform-content-site-how-to-build',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/how-to-build`,
    page: '/platform/content-site/how-to-build',
  },
  {
    name: 'platform-content-site-partner-program',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/partner-program`,
    page: '/platform/content-site/partner-program',
  },
  {
    name: 'platform-content-site-tos',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/tos`,
    page: '/platform/content-site/tos',
  },
  {
    name: 'platform-content-site-acceptable-use',
    pattern: `/${PLATFORM_CONTENT_SITE_MOUNT_POINT}/acceptable-use`,
    page: '/platform/content-site/acceptable-use',
  },
  {
    name: 'platform-bouncer',
    pattern: `/${PLATFORM_BOUNCER_MOUNT_POINT}`,
    page: '/platform/bouncer/index',
  },
  {
    name: 'platform-bouncer-integration',
    pattern: `/${PLATFORM_BOUNCER_MOUNT_POINT}/review/integration/:integrationId`,
    page: '/platform/bouncer/integration',
  },
  {
    name: 'platform-bouncer-review-info',
    pattern: `/${PLATFORM_BOUNCER_MOUNT_POINT}/reviews/:reviewId/info`,
    page: '/platform/bouncer/review',
  },
  {
    name: 'platform-bouncer-review-settings',
    pattern: `/${PLATFORM_BOUNCER_MOUNT_POINT}/reviews/:reviewId/settings`,
    page: '/platform/bouncer/review',
  },
  {
    name: 'platform-bouncer-review-issues',
    pattern: `/${PLATFORM_BOUNCER_MOUNT_POINT}/reviews/:reviewId/issues`,
    page: '/platform/bouncer/review',
  },
  {
    name: 'platform-bouncer-review-issue-viewer',
    pattern: `/${PLATFORM_BOUNCER_MOUNT_POINT}/reviews/:reviewId/issues/:issueId`,
    page: '/platform/bouncer/review',
  },
  {
    name: 'platform-bouncer-review-issue-editor',
    pattern: `/${PLATFORM_BOUNCER_MOUNT_POINT}/reviews/:reviewId/issues/:issueId/edit`,
    page: '/platform/bouncer/review',
  },
  {
    name: 'pricing',
    pattern: `/${PRICING_PAGES_MOUNT_POINT}`,
    page: '/pricing',
  },
  {
    name: 'legal-landing-hub',
    pattern: '/legal',
    page: '/legal/index',
  },
  {
    name: 'terms-of-service',
    pattern: `/tos`,
    page: '/legal/terms-of-service',
  },
  {
    name: 'terms-of-use',
    pattern: `/tou`,
    page: '/legal/terms-of-use',
  },
  {
    name: 'acceptable-use-policy',
    pattern: `/aup`,
    page: '/legal/acceptable-use-policy',
  },
  {
    name: 'privacy',
    pattern: `/${PRIVACY_PAGE_MOUNT_POINT}`,
    page: '/legal/privacy',
  },
  {
    name: 'fastest-growing-apps',
    pattern: `/${APPS_PAGES_MOUNT_POINT}/fastest-growing-apps`,
    page: '/apps/fastest-growing-apps',
  },
  {
    name: 'google-ads-landing',
    pattern: `/${APPS_PAGES_MOUNT_POINT}/google-ads/landing`,
    page: '/apps/google-ads-landing',
  },
  {
    name: 'paths',
    pattern: `/${PATHS_MOUNT_POINT}`,
    page: '/paths/index',
  },
  {
    name: 'press-index',
    pattern: `/${PRESS_PAGES_MOUNT_POINT}`,
    page: '/press/index',
  },
  {
    name: 'accessibility-testing',
    pattern: `/${ACCESSIBILITY_TESTING_MOUNT_POINT}`,
    page: '/accessibility-testing/index',
  },
  {
    name: 'homepage',
    pattern: `/${HOMEPAGE_MOUNT_POINT}`,
    page: '/homepage/index',
  },
  // Homepage variant Q4 2020 - See https://zapierorg.atlassian.net/browse/ATC-798
  {
    name: 'new-homepage',
    pattern: `/home`,
    page: '/foundational-pages/new-homepage',
  },
  {
    isXFrameExempt: X_FRAME_EXEMPT.EXEMPT,
    name: 'partner-template-view',
    // Example path: /partner/facebook-lead-ads/embed/10173/post-slack-channel-messages-new-facebook-lead-ads-leads
    pattern: `/${PARTNER_MOUNT_POINT}/:integrationId/embed/:templateId/:templateSlug`,
    page: '/partners/template-view',
    sessionReplay: {
      forceRecordSession: true,
    },
  },
  {
    isXFrameExempt: X_FRAME_EXEMPT.DANGEROUSLY_ALWAYS,
    name: 'security-iframe-blocked',
    pattern: `/${SECURITY_MOUNT_POINT}/iframe-blocked`,
    page: '/security/iframe-blocked',
  },
  {
    name: 'Publicly Shared Zaps',
    pattern: `/${SHARING_PUBLIC_MOUNT_POINT}/:slugId`,
    page: `/zap-sharing/public-shared-zap`,
  },
  {
    name: 'use-cases-brand-mention-monitoring',
    pattern: `/${USE_CASES_MOUNT_POINT}/brand-mention-monitoring`,
    page: 'use-cases/brand-mention-monitoring',
    sessionReplay: {
      forceRecordSession: true,
    },
  },
  {
    name: 'zap-sharing-page',
    pattern: `/${ZAP_SHARING_MOUNT_POINT}`,
    page: `/zap-sharing/zap-sharing-page`,
  },
  {
    name: 'zappy',
    pattern: `/${ZAPPY_MOUNT_POINT}`,
    page: '/zappy/index',
  },
];

module.exports = routes;
